export default "__VITE_ASSET__2f270e79__"